import { Stylesheet } from './Stylesheet';
import { serializeRuleEntries } from './styleToClassName';
/**
 * Registers a font face.
 * @public
 */
export function fontFace(font) {
    Stylesheet.getInstance().insertRule("@font-face{" + serializeRuleEntries(font) + "}", true);
}
//# sourceMappingURL=fontFace.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/merge-styles/lib/fontFace.js
// module id = 118
// module chunks = 0